var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import * as ScoreType from '../../../../constants/ScoreType';
import PeriodScores from './PeriodScores';
var TableTennisStatistic = /** @class */ (function (_super) {
    __extends(TableTennisStatistic, _super);
    function TableTennisStatistic() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableTennisStatistic.prototype.render = function () {
        var _a = this.props, additionalScores = _a.additionalScores, match = _a.match, short = _a.short, periodInfo = _a.periodInfo;
        var firstTeam = match.get('firstTeam');
        var secondTeam = match.get('secondTeam');
        var scores = this.getScores();
        var firstServe = (scores.isFirstTeamServe) ? 'server active' : 'server';
        var secondServe = (scores.isSecondTeamServe) ? 'server active' : 'server';
        var firstTeamSets = scores.firstTeamSets > scores.secondTeamSets ? (_jsx("strong", { children: scores.firstTeamSets })) : scores.firstTeamSets;
        var secondTeamSets = scores.secondTeamSets > scores.firstTeamSets ? (_jsx("strong", { children: scores.secondTeamSets })) : scores.secondTeamSets;
        if (short) {
            return (_jsxs("div", __assign({ className: 'board short-board' }, { children: [_jsx("div", __assign({ className: 'time' }, { children: periodInfo.period })), _jsx("div", __assign({ className: 'short-board__items' }, { children: _jsxs("div", __assign({ className: 'short-board__item short-board__item--total' }, { children: [_jsx("div", { children: "\u0441\u0447\u0435\u0442:" }), _jsxs("div", __assign({ className: 'short-board__item--total__main' }, { children: [scores.isFirstTeamServe && '*', firstTeamSets, ":", secondTeamSets, scores.isSecondTeamServe && '*'] })), _jsx("div", __assign({ className: 'short-board__additional-scores' }, { children: _jsx(PeriodScores, { additionalScores: additionalScores, short: short }) }))] })) }))] })));
        }
        return (_jsxs("div", __assign({ className: 'board' }, { children: [(this.props.scores && this.props.scores.size > 0) && _jsxs("div", __assign({ className: 'scores_baord' }, { children: [_jsxs("div", __assign({ className: 'score ttennis-feed' }, { children: [_jsx("div", { className: 'tit' }), _jsx("div", __assign({ className: 'num' }, { children: _jsx("div", { className: firstServe }) })), _jsx("div", __assign({ className: 'num' }, { children: _jsx("div", { className: secondServe }) }))] })), _jsxs("div", __assign({ className: 'total selected' }, { children: [_jsx("div", { className: 'tit', title: '' }), _jsx("div", __assign({ className: 'num' }, { children: firstTeamSets })), _jsx("div", __assign({ className: 'num' }, { children: secondTeamSets }))] })), _jsx(PeriodScores, { additionalScores: additionalScores })] })), _jsxs("div", __assign({ className: 'main' }, { children: [_jsx("div", __assign({ className: 'time' }, { children: _jsx("sub", { children: periodInfo.period }) })), _jsx("div", __assign({ className: 'name' }, { children: firstTeam })), _jsx("div", __assign({ className: 'name' }, { children: secondTeam }))] }))] })));
    };
    TableTennisStatistic.prototype.getScores = function () {
        var scores = this.props.scores;
        var defaultScore = new Map({ score1: 0, score2: 0 });
        var matchScores = (scores.filter(function (score) { return score.get('type') == ScoreType.Match; }).first() || defaultScore).toJS();
        var feedScore = (scores.find(function (s) { return s.get('type') == ScoreType.Feed; }) || defaultScore).toJS();
        return {
            firstTeamSets: matchScores.score1,
            secondTeamSets: matchScores.score2,
            isFirstTeamServe: feedScore.team === 1,
            isSecondTeamServe: feedScore.team === 2
        };
    };
    return TableTennisStatistic;
}(React.Component));
TableTennisStatistic.propTypes = {
    short: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired,
    scores: PropTypes.object.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    additionalScores: PropTypes.any,
};
export default TableTennisStatistic;



// WEBPACK FOOTER //
// ./src/components/grid/event/statistics/TableTennis.jsx